import React from 'react';
import styled from 'styled-components';
import TwitterApi, { TwitterResponseTypes } from '../../api/twitter';
import AppSettings from '../../settings';
import { Container } from '../../styled-components/Layout';

const TwitterTestContainer = styled(Container)`
  align-items: middle;
  justify-content: baseline;
  padding: 1rem;
  flex-direction: column;
  overflow-y: scroll;
`;

const Group = styled.div`
  display: flex;
  justify-content: baseline;
  align-items: ${props => (props.vertical ? 'flex-start' : 'center')};
  margin: 0.5rem;
  flex-direction: ${props => (props.vertical ? 'column' : 'row')};
`;

const Button = styled.button`
  inherit: none;
  height: 28px;
  display: inline-block;
  border-radius: 3px;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  background-color: #1b95e0;
  color: white;
  background: #1b95e0
    url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2072%2072%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h72v72H0z%22%2F%3E%3Cpath%20class%3D%22icon%22%20fill%3D%22%23fff%22%20d%3D%22M68.812%2015.14c-2.348%201.04-4.87%201.744-7.52%202.06%202.704-1.62%204.78-4.186%205.757-7.243-2.53%201.5-5.33%202.592-8.314%203.176C56.35%2010.59%2052.948%209%2049.182%209c-7.23%200-13.092%205.86-13.092%2013.093%200%201.026.118%202.02.338%202.98C25.543%2024.527%2015.9%2019.318%209.44%2011.396c-1.125%201.936-1.77%204.184-1.77%206.58%200%204.543%202.312%208.552%205.824%2010.9-2.146-.07-4.165-.658-5.93-1.64-.002.056-.002.11-.002.163%200%206.345%204.513%2011.638%2010.504%2012.84-1.1.298-2.256.457-3.45.457-.845%200-1.666-.078-2.464-.23%201.667%205.2%206.5%208.985%2012.23%209.09-4.482%203.51-10.13%205.605-16.26%205.605-1.055%200-2.096-.06-3.122-.184%205.794%203.717%2012.676%205.882%2020.067%205.882%2024.083%200%2037.25-19.95%2037.25-37.25%200-.565-.013-1.133-.038-1.693%202.558-1.847%204.778-4.15%206.532-6.774z%22%2F%3E%3C%2Fsvg%3E')
    no-repeat 2px 1px;
  border: 1px solid #cccccc;
  padding-left: 2rem;
  padding-right: 4px;
  padding-top: 2px;

  font-weight: bold;
  font-size: 13px;
  font-family: Arial;
  text-decoration: none;
`;

const FieldSet = styled.fieldset`
  margin-bottom: 1rem;
`;

const TextBox = styled.input`
  height: 28px;
  margin-right: 0.5rem;
`;

class TwitterApiTest extends React.PureComponent {
  constructor() {
    super();

    this.twitterApi = {};
    this.state = {
      user: {},
      authResponse: {},
      mediaFilePath: '',
      mediaResponse: {},
      status: ''
    };
  }

  componentDidMount = () => {
    this.twitterApi = new TwitterApi(AppSettings.credentialManagerPath, this.onResponse);
  };

  onResponse = response => {
    if (response.type === TwitterResponseTypes.AUTH) {
      if (response.error) {
        this.setState({ authResponse: response.data });
      } else {
        this.setState({ user: response.data });
      }
    } else if (response.type === TwitterResponseTypes.TWEET) {
      this.setState({ mediaResponse: response.error || response.data });
    }
  };

  render() {
    const { user, authResponse, mediaFilePath, mediaResponse, status } = this.state;
    return (
      <TwitterTestContainer>
        <h1>Twitter API Test</h1>
        <FieldSet>
          <legend>User Information</legend>
          <Group vertical>
            <div>Logged in: {user ? 'Yes' : 'No'}</div>
            <div>
              {user ? (
                <div>
                  <pre>{JSON.stringify(user, null, 2)}</pre>
                </div>
              ) : (
                '{}'
              )}
            </div>
          </Group>
        </FieldSet>
        <FieldSet>
          <legend>Authentication:</legend>
          <Group>
            <Button
              onClick={() => {
                this.twitterApi
                  .loginDialog()
                  .then(() => this.setState({ authResponse: {} }))
                  .catch(error => this.setState({ authResponse: error }));
              }}
            >
              Login Popup
            </Button>
            <Button
              onClick={() => {
                this.twitterApi
                  .loginDialog(true)
                  .then(() => this.setState({ authResponse: {} }))
                  .catch(error => this.setState({ authResponse: error }));
              }}
            >
              Force Login Popup
            </Button>
            <Button
              onClick={() => {
                this.twitterApi
                  .logout()
                  .then(() => this.setState({ authResponse: {} }))
                  .catch(error => this.setState({ authResponse: error }));
              }}
            >
              Local Logout
            </Button>
          </Group>
          <div>
            Response:
            <div>
              <pre>{JSON.stringify(authResponse, null, 2)}</pre>
            </div>
          </div>
        </FieldSet>
        <FieldSet>
          <legend>Tweet:</legend>
          <Group>
            <Button
              onClick={() => {
                this.setState({ mediaResponse: {} });
                this.twitterApi
                  .tweet(status, mediaFilePath)
                  .then(r => this.setState({ mediaResponse: r }))
                  .catch(err => {
                    if (err.message) {
                      return this.setState({ mediaResponse: err.message });
                    }
                    this.setState({ mediaResponse: err });
                  });
              }}
            >
              Tweet
            </Button>
            <TextBox
              type="text"
              placeholder="Status"
              value={status}
              onChange={e => this.setState({ status: e.target.value })}
            />
            <TextBox
              type="text"
              placeholder="File Path"
              value={mediaFilePath}
              onChange={e => this.setState({ mediaFilePath: e.target.value })}
            />
          </Group>
          <div>
            Response:
            <div>
              <pre>{JSON.stringify(mediaResponse, null, 2)}</pre>
            </div>
          </div>
        </FieldSet>
      </TwitterTestContainer>
    );
  }
}

export default TwitterApiTest;



// WEBPACK FOOTER //
// ./app/components/Test/TwitterApiTest.js